<template>
  <q-modal ref="mod" minimized position-classes="items-start justify-end" v-model="opened">
    <div class="column items-start">
      <q-btn no-caps color="primary" size="lg"
             align="left" class="full-width" flat icon="photo_camera">
        Фото
        <input
          type="file"
          multiple
          class="q-uploader-input absolute-full cursor-pointer"
          accept="image/*"
          @change="done"
          @click="hide"
        >
      </q-btn>
      <q-btn no-caps color="primary" size="lg"
             align="left" class="full-width" flat icon="mic">
        Аудио
        <input
          type="file"
          multiple
          class="q-uploader-input absolute-full cursor-pointer"
          accept="audio/*"
          @change="done"
          @click="hide"
        >
      </q-btn>
      <q-btn no-caps color="primary" size="lg"
             align="left" class="full-width" flat icon="videocam">
        Видео
        <input
          type="file"
          multiple
          class="q-uploader-input absolute-full cursor-pointer"
          accept="video/*"
          @change="done"
          @click="hide"
        >
      </q-btn>
      <q-btn no-caps color="primary"
             size="lg" align="left" class="full-width" flat icon="insert_drive_file">
        Документ
        <input
            multiple
            type="file"
            class="q-uploader-input absolute-full cursor-pointer"
            accept="*"
            @change="done"
            @click="hide"
        >
      </q-btn>
      <q-btn no-caps color="primary" size="lg"
             align="left" class="full-width" flat icon="place" @click="pickPlace">
        Место
      </q-btn>
    </div>
  </q-modal>
</template>

<script>

export default {
  name: 'media-modal',
  props: {
    done: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      accept: '*',
      opened: false,
    };
  },
  computed: {
  },
  methods: {
    open() {
      console.log('open');
      this.opened = true;
    },
    hide() {
      console.log('MEDIAMODAL hide', this.$refs.mod);
      this.opened = false;
    },
    pickPlace() {
      this.opened = false;
      if (!('geolocation' in window.navigator)) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Функция не поддерживается',
        });
      } else {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            this.done(position);
          },
          () => {
            this.$store.commit('pushError', {
              error: 'Ошибка!',
              message: 'Нет доступа к местоположению',
            });
          },
        );
      }
    },
    fromBuffer() {
      this.opened = false;
      this.done('fromBuffer');
    },
  },
};
</script>

<style lang="stylus">
.full-width
  .q-icon
    padding 0 10px
</style>



// WEBPACK FOOTER //
// src/components/media-modal.vue